import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../App';
import {
  Button,
  Flex,
  Icon,
  InputText,
  InputTextArea,
  PageHeader,
  Space,
} from '../atoms';

const StyledBody = styled.div`
  margin: 50px;
  padding: 20px;
  width: 600px;
`;

const SubTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  padding: 5px 0;
`;

const DISABLED_OPACITY = 0.1;
const PLACEHOLDER_OPACITY = 0.4;

export const Login = observer(() => {
  const root = useRootStore();
  const {
    serviceId,
    serviceAttribute,
    token,
    onChangeServiceId,
    onChangeServiceAttribute,
    onChangeToken,
    hintToken,
    hints,
    createToken,
    devLogin,
    encodedToken,
    onClickHint,
    isCreateTokenDisabled,
    isLoginDisabled,
    simulateLoginFromExternalDomain,
  } = root.loginStore;

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Flex center>
      <StyledBody
        style={{
          height: windowDimensions.height - 150,
          overflow: 'auto',
        }}
      >
        <PageHeader>
          <Icon name="i-rms-ac-comment" />
          &nbsp;問い合わせ管理 開発ログイン
        </PageHeader>
        <form>
          <Space height={10} />
          <div className="rms-row">
            <div className="rms-col-md-24">
              <SubTitle>
                1. Choose post-login state (ログイン後の状態を選択)
              </SubTitle>
            </div>
            <div className={'rms-row'}>
              <div style={{ marginTop: 6 }}>Samples (サンプルを選択):</div>
              <div>
                {hints.map((hint, index) => {
                  return (
                    <div
                      key={`hint-${index}`}
                      className="rms-col-md-6"
                      style={{ paddingTop: 5 }}
                    >
                      <Button onClick={() => onClickHint(index)} color="blue">
                        {hint.name}
                      </Button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <Space height={5} />
          <div className="rms-row">
            <div className={'rms-row'}>
              <div className="rms-col-md-24">
                <SubTitle>1.5. Customize attributes (Optional)</SubTitle>
              </div>
              <div className="rms-col-md-12">
                <div>Service ID</div>
                <InputText
                  value={serviceId}
                  onChange={onChangeServiceId}
                  hint="1"
                  placeholderOpacity={PLACEHOLDER_OPACITY}
                />
              </div>
            </div>
            <div className={'rms-row'}>
              <div className="rms-col-md-12">
                <div className="rms-col-md-12">
                  <div>Service Attribute</div>
                  <InputText
                    value={serviceAttribute}
                    onChange={onChangeServiceAttribute}
                    hint="1"
                    placeholderOpacity={PLACEHOLDER_OPACITY}
                  />
                </div>
              </div>
            </div>
            <div className="rms-row">
              <div className="rms-col-md-24">
                <div>Token</div>
                <InputTextArea
                  value={token}
                  onChange={onChangeToken}
                  hint={hintToken}
                  height={100}
                  width={500}
                  placeholderOpacity={PLACEHOLDER_OPACITY}
                />
              </div>
            </div>
          </div>

          <Space height={5} />
          <div
            className="rms-row"
            style={{
              marginBottom: 50,
              opacity: isCreateTokenDisabled ? DISABLED_OPACITY : 1,
            }}
          >
            <div className="rms-col-md-24">
              <SubTitle>2-A. Omni Login</SubTitle>
              <div>
                (ConsumerアカウントはOmni時のアカウントに上書きされます)
              </div>
              <div>(Consumer account is overwritten by Omni account)</div>
            </div>
            <div className="rms-row">
              <div style={{ paddingTop: 5 }}>
                <Button onClick={() => simulateLoginFromExternalDomain(false)}>
                  施設へ問い合わせ (update lastly-used Omni Token)
                </Button>
              </div>
              <div style={{ paddingTop: 5 }}>
                <Button onClick={() => simulateLoginFromExternalDomain(true)}>
                  施設へ問い合わせ (newly create Omni Token)
                </Button>
              </div>
            </div>
          </div>
          <Space height={5} />
          <div
            className="rms-row"
            style={{ opacity: isCreateTokenDisabled ? DISABLED_OPACITY : 1 }}
          >
            <div className="rms-col-md-24">
              <SubTitle>2-B. no Omni Login (Create a token)</SubTitle>
            </div>
            <div className="rms-row" style={{ textAlign: 'center' }}>
              <div className="rms-col-md-24">
                <Button
                  onClick={() => createToken()}
                  disabled={isCreateTokenDisabled}
                >
                  JWT作成
                </Button>
              </div>
              <div className="rms-col-md-24" style={{ marginTop: 10 }}>
                Token: {encodedToken}
              </div>
            </div>
          </div>
          <Space height={5} />
          <div
            className="rms-row"
            style={{
              opacity: isLoginDisabled ? DISABLED_OPACITY : 1,
            }}
          >
            <div className="rms-col-md-24">
              <SubTitle>3. Login (ログインを実行)</SubTitle>
            </div>
            <div className="rms-row" style={{ textAlign: 'center' }}>
              <Button
                onClick={() => devLogin('inquiry')}
                disabled={isLoginDisabled}
              >
                ログイン
              </Button>
              <Button
                onClick={() => devLogin('inquiry/new')}
                disabled={isLoginDisabled}
              >
                新規問い合わせ
              </Button>
            </div>
          </div>
        </form>
      </StyledBody>
    </Flex>
  );
});
